const container = document.querySelector('.all-brands')

if (container) {

    const buttons = Array.from(container.querySelectorAll('button'))
    const groups = Array.from(container.querySelectorAll('.all-brands__grid > li'))

    buttons.forEach(button => {
        button.addEventListener("click", () => {
            buttons.forEach(buttonElement => {
                buttonElement.classList.remove('button--primary')
                buttonElement.classList.add('button--secondary')
            })

            button.classList.remove('button--secondary')
            button.classList.add('button--primary')

            const buttonFilter = button.dataset.value
            const isFilterApplied = buttonFilter !== 'ALL'

            groups.forEach(group => {
                const groupName = group.dataset.value

                if (!isFilterApplied || groupName === buttonFilter) {
                    group.style.display = 'block'
                } else {
                    group.style.display = 'none'
                }
            })
        })
    })
}